/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {useIsMobile} from "../../../table/Table";
import {CartRowSkeletonMobile} from "./CartRowSkeletonMobile";
import {CartRowHeaderSkeleton} from "./CartRowHeaderSkeleton";
import {CartRowSkeleton} from "./CartRowSkeleton";

export const CartSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(4)].map((item, i) => <CartRowSkeletonMobile key={i}/>)}</>
        :
        <><CartRowHeaderSkeleton/>{[...Array(5)].map((item, i) => <CartRowSkeleton key={i}/>)}</>
}

